import * as React from "react";
import { Loader } from "@grandvisionhq/common";
import { RequiredFieldsLabel } from "@grandvisionhq/forms";
import { Consents } from "../../modules/Consents/layout/modules/Consents/layout/Consents.js";
import { Footer } from "../../modules/Footer/modules/Footer/Footer.js";
import { BillingAndDeliveryForm } from "../components/AddressesSection/BillingAndDeliveryForm/StepShipping/components/AddressesSection/BillingAndDeliveryForm/BillingAndDeliveryForm.js";
import { AlternateShippingMethodsModal } from "../components/AlternativeShippingMethodsList/StepShipping/components/AlternativeShippingMethodsList/AlternateShippingMethodsModal.js";
import { CompanySelect } from "../components/CompanySelect/StepShipping/components/CompanySelect/CompanySelect.js";
/* empty css                  */
import { TitleWithIcon } from "../../components/TitleWithIcon/components/TitleWithIcon/TitleWithIcon.js";
import { ShippingMethods } from "../modules/ShippingMethods/layouts/StepShipping/modules/ShippingMethods/layouts/ShippingMethods.js";
import { CompanyFormContainer } from "../containers/StepShipping/containers/CompanyFormContainer.js";
import { ContactDetailsContainer } from "../containers/StepShipping/containers/ContactDetailsContainer.js";
import { InvoiceFormContainer } from "../containers/StepShipping/containers/InvoiceFormContainer.js";
import { ServiceStoreHeading } from "../../modules/ServiceStore/layout/modules/ServiceStore/layout/ServiceStoreHeading.js";
import { ServiceStore } from "../../modules/ServiceStore/layout/modules/ServiceStore/layout/ServiceStore.js";
import { ImplicitTermsAndConditionsContainer } from "../containers/StepShipping/containers/ImplicitTermsAndConditionsContainer.js";
import { StepNames } from "../../models/models/shared.js";
import { ImplicitAccountCreationContainer } from "../containers/StepShipping/containers/ImplicitAccountCreationContainer.js";
const StepShipping = ({
  labels,
  onNextStep,
  onPrevStep,
  isFirstStep,
  shippingMethodsAsides,
  shouldShowLoader,
  handleOptInsLoading,
  handleServiceStoreLoading,
  onCloseUpdatedShippingMethodsModal,
  shouldShowUpdatedShippingMethodsModal = false
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: "checkout-step checkout-step--shipping" }, /* @__PURE__ */ React.createElement(TitleWithIcon, { icon: "orders", label: labels.shipmentMethodTitle }), /* @__PURE__ */ React.createElement(ShippingMethods, { shippingMethodsAsides }), /* @__PURE__ */ React.createElement(TitleWithIcon, { icon: "billing", label: labels.generic.title }), /* @__PURE__ */ React.createElement(RequiredFieldsLabel, null), /* @__PURE__ */ React.createElement(CompanySelect, null), /* @__PURE__ */ React.createElement(CompanyFormContainer, null), shouldShowLoader ? /* @__PURE__ */ React.createElement("div", { className: "checkout-step--shipping__loader" }, /* @__PURE__ */ React.createElement(Loader, null)) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BillingAndDeliveryForm, null), /* @__PURE__ */ React.createElement(ContactDetailsContainer, null), /* @__PURE__ */ React.createElement(InvoiceFormContainer, null), /* @__PURE__ */ React.createElement(
    ServiceStoreHeading,
    {
      shouldHideIcon: false,
      title: labels.serviceStoreTitle,
      subtitle: labels.serviceStoreSubtitle
    }
  ), /* @__PURE__ */ React.createElement(ServiceStore, { handleServiceStoreLoading })), /* @__PURE__ */ React.createElement(Consents, { handleOptInsLoading }), /* @__PURE__ */ React.createElement(ImplicitTermsAndConditionsContainer, null), /* @__PURE__ */ React.createElement(
    Footer,
    {
      stepName: StepNames.Shipping,
      onPrevStep,
      onNextStep,
      isFirstStep
    }
  ), /* @__PURE__ */ React.createElement(ImplicitAccountCreationContainer, null), /* @__PURE__ */ React.createElement(
    AlternateShippingMethodsModal,
    {
      onNextStep: () => onNextStep(true),
      closeUpdatedShippingMethodsModal: onCloseUpdatedShippingMethodsModal,
      shouldShowUpdatedShippingMethodsModal
    }
  ));
};
export {
  StepShipping
};
//# sourceMappingURL=StepShipping.js.map
